export default __webpack_public_path__ + "ab6102e97fb27ad0618f46a025b9e550.png";